/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset } from './PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset';
import {
  PerturbedDatasetPolymorphicPerturbedConversationalAgentDatasetFromJSON,
  PerturbedDatasetPolymorphicPerturbedConversationalAgentDatasetFromJSONTyped,
  PerturbedDatasetPolymorphicPerturbedConversationalAgentDatasetToJSON,
} from './PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset';
import type { PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset } from './PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset';
import {
  PerturbedDatasetPolymorphicPerturbedInformationExtractionDatasetFromJSON,
  PerturbedDatasetPolymorphicPerturbedInformationExtractionDatasetFromJSONTyped,
  PerturbedDatasetPolymorphicPerturbedInformationExtractionDatasetToJSON,
} from './PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset';
import type { PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset } from './PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset';
import {
  PerturbedDatasetPolymorphicPerturbedSingleTurnChatDatasetFromJSON,
  PerturbedDatasetPolymorphicPerturbedSingleTurnChatDatasetFromJSONTyped,
  PerturbedDatasetPolymorphicPerturbedSingleTurnChatDatasetToJSON,
} from './PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset';
import type { PerturbedDatasetPolymorphicPerturbedTabularMLDataset } from './PerturbedDatasetPolymorphicPerturbedTabularMLDataset';
import {
  PerturbedDatasetPolymorphicPerturbedTabularMLDatasetFromJSON,
  PerturbedDatasetPolymorphicPerturbedTabularMLDatasetFromJSONTyped,
  PerturbedDatasetPolymorphicPerturbedTabularMLDatasetToJSON,
} from './PerturbedDatasetPolymorphicPerturbedTabularMLDataset';
import type { PerturbedDatasetPolymorphicPerturbedTextGenerationDataset } from './PerturbedDatasetPolymorphicPerturbedTextGenerationDataset';
import {
  PerturbedDatasetPolymorphicPerturbedTextGenerationDatasetFromJSON,
  PerturbedDatasetPolymorphicPerturbedTextGenerationDatasetFromJSONTyped,
  PerturbedDatasetPolymorphicPerturbedTextGenerationDatasetToJSON,
} from './PerturbedDatasetPolymorphicPerturbedTextGenerationDataset';
import type { PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset } from './PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset';
import {
  PerturbedDatasetPolymorphicPerturbedVoiceAgentDatasetFromJSON,
  PerturbedDatasetPolymorphicPerturbedVoiceAgentDatasetFromJSONTyped,
  PerturbedDatasetPolymorphicPerturbedVoiceAgentDatasetToJSON,
} from './PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset';

/**
 * @type PerturbedDatasetPolymorphic
 *
 * @export
 */
export type PerturbedDatasetPolymorphic =
  | ({ taskType: 'conversational_agent' } & PerturbedDatasetPolymorphicPerturbedConversationalAgentDataset)
  | ({ taskType: 'information_extraction' } & PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset)
  | ({ taskType: 'single_turn_chat' } & PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset)
  | ({ taskType: 'tabular_ml' } & PerturbedDatasetPolymorphicPerturbedTabularMLDataset)
  | ({ taskType: 'text_generation' } & PerturbedDatasetPolymorphicPerturbedTextGenerationDataset)
  | ({ taskType: 'voice_agent' } & PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset);

export function PerturbedDatasetPolymorphicFromJSON(json: any): PerturbedDatasetPolymorphic {
  return PerturbedDatasetPolymorphicFromJSONTyped(json, false);
}

export function PerturbedDatasetPolymorphicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerturbedDatasetPolymorphic {
  if (json == null) {
    return json;
  }
  switch (json['task_type']) {
    case 'conversational_agent':
      return Object.assign(
        {},
        PerturbedDatasetPolymorphicPerturbedConversationalAgentDatasetFromJSONTyped(json, true),
        { taskType: 'conversational_agent' } as const,
      );
    case 'information_extraction':
      return Object.assign(
        {},
        PerturbedDatasetPolymorphicPerturbedInformationExtractionDatasetFromJSONTyped(json, true),
        { taskType: 'information_extraction' } as const,
      );
    case 'single_turn_chat':
      return Object.assign({}, PerturbedDatasetPolymorphicPerturbedSingleTurnChatDatasetFromJSONTyped(json, true), {
        taskType: 'single_turn_chat',
      } as const);
    case 'tabular_ml':
      return Object.assign({}, PerturbedDatasetPolymorphicPerturbedTabularMLDatasetFromJSONTyped(json, true), {
        taskType: 'tabular_ml',
      } as const);
    case 'text_generation':
      return Object.assign({}, PerturbedDatasetPolymorphicPerturbedTextGenerationDatasetFromJSONTyped(json, true), {
        taskType: 'text_generation',
      } as const);
    case 'voice_agent':
      return Object.assign({}, PerturbedDatasetPolymorphicPerturbedVoiceAgentDatasetFromJSONTyped(json, true), {
        taskType: 'voice_agent',
      } as const);
    default:
      throw new Error(`No variant of PerturbedDatasetPolymorphic exists with 'taskType=${json['taskType']}'`);
  }
}

export function PerturbedDatasetPolymorphicToJSON(value?: PerturbedDatasetPolymorphic | null): any {
  if (value == null) {
    return value;
  }
  switch (value['taskType']) {
    case 'conversational_agent':
      return PerturbedDatasetPolymorphicPerturbedConversationalAgentDatasetToJSON(value);
    case 'information_extraction':
      return PerturbedDatasetPolymorphicPerturbedInformationExtractionDatasetToJSON(value);
    case 'single_turn_chat':
      return PerturbedDatasetPolymorphicPerturbedSingleTurnChatDatasetToJSON(value);
    case 'tabular_ml':
      return PerturbedDatasetPolymorphicPerturbedTabularMLDatasetToJSON(value);
    case 'text_generation':
      return PerturbedDatasetPolymorphicPerturbedTextGenerationDatasetToJSON(value);
    case 'voice_agent':
      return PerturbedDatasetPolymorphicPerturbedVoiceAgentDatasetToJSON(value);
    default:
      throw new Error(`No variant of PerturbedDatasetPolymorphic exists with 'taskType=${value['taskType']}'`);
  }
}
